import { Badge } from '@mantine/core';
import type { ChargeState } from '@taksikortti/shared';
import { t } from '../lib/strings';

// Aggregated per-row invoice (Myyntilaskutustila) / payment (Tilitystila) state.
// approved = will be billed/paid SOON (handle first) → blue; active = done → green;
// pending = not yet processed → yellow; blocked = won't be billed/paid → gray.
const COLORS: Record<ChargeState, string> = {
  approved: 'blue',
  active: 'green',
  pending: 'yellow',
  blocked: 'gray',
  none: 'gray',
};

export function ChargeStateBadge({ state }: { state: ChargeState }) {
  if (state === 'none') return <>—</>;
  return (
    <Badge color={COLORS[state]} variant="light" size="xs" radius="sm">
      {t.chargeState[state] ?? state}
    </Badge>
  );
}
